import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import NewArticleSummaryFeedback from './NewArticleSummaryFeedback'
import NewArticleSummaryHeader from './NewArticleSummaryHeader'
import SummaryContent from './SummaryContent'

const StyledContainer = styled.div`
  ${({
    theme: {
      colors: { fillWeak },
      spacing: { spacing12, spacing16, spacing24 },
    },
  }) => css`
    background-color: ${fillWeak};
    padding: ${spacing24} ${spacing16};
    display: flex;
    flex-direction: column;
    gap: ${spacing12};
  `}
`

const StyledHeader = styled(NewArticleSummaryHeader)`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    margin-bottom: ${spacing4};
  `}
`

const NewArticleSummary: FunctionComponent<{ summaryText: string }> = ({
  summaryText,
}) => {
  return (
    <StyledContainer>
      <StyledHeader />
      <SummaryContent text={summaryText} />
      <NewArticleSummaryFeedback text={summaryText} />
    </StyledContainer>
  )
}

export default NewArticleSummary
